import React from 'react';

import './Button.scss';

const ButtonBase = ({
  as = 'button',
  children,
  variant = 'primary',
  size = 'md',
  leftIcon,
  rightIcon,
  iconOnly = false,
  disabled = false,
  fullWidth = false,
  className = '',
  extraClass = '',
  ...props
}) => {
  const classes = [
    'button',
    `button--${variant}`,
    `button--${size}`,
    iconOnly ? `button--iconOnly button--${size}` : '',
    fullWidth ? 'button--full-width' : '',
    extraClass,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  if (as === 'external-link') {
    const href = props.to || props.href || '/';
    return (
      <a className={classes} href={href} {...props}>
        {leftIcon && <span className="icon">{leftIcon}</span>}
        {!iconOnly && <span className="label">{children}</span>}
        {rightIcon && <span className="icon">{rightIcon}</span>}
      </a>
    );
  }

  return (
    <button className={classes} disabled={disabled} type="button" {...props}>
      {leftIcon && <span className="icon">{leftIcon}</span>}
      {!iconOnly && <span className="label">{children}</span>}
      {rightIcon && <span className="icon">{rightIcon}</span>}
    </button>
  );
};

const Button = (props) => <ButtonBase {...props} />;

Button.Animated = ({
  children,
  leftIcon,
  rightIcon,
  iconOnly,
  disabled,
  size = 'md',
  as = 'button',
  ...props
}) => {
  const animatedClass = `animation button--${size}`;
  return (
    <ButtonBase
      {...props}
      as={as}
      size={size}
      leftIcon={leftIcon}
      rightIcon={rightIcon}
      iconOnly={iconOnly}
      disabled={disabled}
      extraClass={animatedClass}
    >
      {children}
    </ButtonBase>
  );
};

export default Button;
